export default __webpack_public_path__ + "static/media/cherry.beafdfb9.png";